export const SET_LOADING_STATE = "ssUploader.SET_LOADING_STATE";
export const SET_ERROR_TYPE = "ssUploader.SET_ERROR_TYPE";
export const SET_TOTAL_UPLOADED_CARDS_COUNT =
  "ssUploader.SET_TOTAL_UPLOADED_CARDS_COUNT";
export const SET_TOTAL_ERROR_CARDS_COUNT =
  "ssUploader.SET_TOTAL_ERROR_CARDS_COUNT";
export const SET_TOTAL_SUCCESS_CARDS_COUNT =
  "ssUploader.SET_TOTAL_SUCCESS_CARDS_COUNT";
export const SET_ERROR_CARDS = "ssUploader.SET_ERROR_CARDS";
export const RESET_CARDS = "ssUploader.RESET_CARDS";
export const REMOVE_ERROR_CARD = "ssUploader.REMOVE_ERROR_CARD";

export const LOADING_EMUNS = Object.freeze({
  DEFAULT: "DEFAULT",
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
});

export const ERROR_EMUNS = Object.freeze({
  DEFAULT: "DEFAULT",
  INVALID_FILE: "INVALID_FILE",
  VALIDATION: "VALIDATION",
  SERVER: "SERVER",
});

export const CARD_STATUS = Object.freeze({
  DEFAULT: "DEFAULT",
  ERROR: "ERROR",
  VALID: "VALID",
});
